import React, { FC, useCallback, useState } from 'react'
import { useReactiveVar } from '@apollo/client'
import { Button } from '@wmgtech/legato'
import { useAbility } from '@casl/react'

import { AbilityContext } from 'shared/abilities'
import { useZonesList } from 'modulesCommon/serviceHooks'

import { FeedForm, ZoneConfirmationModal } from '..'
import { activeProjectVar, labelCodeIdVar } from 'modulesCommon/store'
import { useCurrentUser } from 'modules/User/useCurrentUser'

import { AddNewStoryProps } from './AddNewStory.props'
import './AddNewStory.scss'

const AddNewStory: FC<AddNewStoryProps> = ({
  isEditorActive,
  toggleHandler,
  feedHandler,
  tags,
  searchItems,
  searchResult,
  storyGuide,
  isEditorLoading,
  children,
  isFeedPage
}) => {
  const [isConfirmation, toggleConfirmation] = useState(false)
  const { user } = useCurrentUser()
  const currentLabelId = useReactiveVar(labelCodeIdVar)
  const activeProject = useReactiveVar(activeProjectVar)
  const { getZoneById } = useZonesList()

  const onAddStory = useCallback(() => {
    if (currentLabelId && user?.label_id !== currentLabelId) {
      toggleConfirmation(true)
    } else {
      toggleHandler()
    }
  }, [user?.label_id, currentLabelId, toggleHandler])

  const ability = useAbility(AbilityContext)
  const isAddStoryButtonShown = isFeedPage ? true : activeProject?.active
  return (
    <div className="new-story">
      <div className="new-story__actions">
        {(
          ability.can('create', 'Story')
        ) && (
          isAddStoryButtonShown && (
            <Button
              data-edit-mode
              className="new-story__button"
              containerStyle="solid"
              colorType="secondary-black"
              disabled={isEditorActive}
              onClick={onAddStory}
              label="New Story"
              secondaryIcon="circle-plus"
            />
          )
        )}
        <div className="new-story__button--right">{children}</div>
      </div>
      {
        isEditorActive && (
          <FeedForm
            handleCloseForm={toggleHandler}
            feedHandler={feedHandler}
            tagsList={tags}
            isCreateFeed
            searchItems={searchItems}
            searchResult={searchResult}
            storyGuide={storyGuide}
            dataTestPrefix="add-new-post_edit"
            isEditorLoading={isEditorLoading}
          />
        )
      }
      <ZoneConfirmationModal
        isOpen={isConfirmation}
        title={`New story in Zone ${getZoneById(currentLabelId)?.alias}?`}
        text={<>Are you sure you want to create a story in the zone <b>{getZoneById(currentLabelId)?.name}</b>?</>}
        onClose={() => toggleConfirmation(false)}
        onContinue={toggleHandler}
      />
    </div>
  )
}

export default AddNewStory
